// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3uy03","content":"Consent_content__3Y07N","footer":"Consent_footer__3Ip_E"};